/**
 * The `File` objects behind a message that is still in flight.
 *
 * They cannot live in Redux — a `File` is not serialisable — but a retry needs
 * the actual bytes, not the filenames the pending row carries. Keeping them
 * here, keyed by the same client token the send uses, is what lets a retry
 * resend the attachments instead of quietly posting the text on its own.
 *
 * `recall` returning `undefined` for a message the pending row says had files
 * means they are gone and the user has to attach them again. Treating that as
 * "no attachments" would send a stripped message under the same token.
 */
const inFlight = new Map<string, File[]>()

export const rememberAttachments = (token: string, files: File[]): void => {
  if (files.length) inFlight.set(token, files)
}

/** The files for this token, or `undefined` if they were never kept or are gone. */
export const recallAttachments = (token: string): File[] | undefined =>
  inFlight.get(token)

export const forgetAttachments = (token: string): void => {
  inFlight.delete(token)
}

/** Whether this token was sent with attachments at all. */
export const hadAttachments = (token: string): boolean => inFlight.has(token)
